/* Al Basha Silver - discount bar (added by Claude)
   - highlights the code and copies it on tap
   - rotates through extra messages every 4 seconds:
     pay on delivery, 2-day refund, 14-day exchange, trust */
(function () {
  var CODE_RE = /\b([A-Z]{3,}[0-9]{1,3})\b/;
  var INTERVAL = 4000;

  function build() {
    var isAr = (document.documentElement.lang || 'ar').indexOf('ar') === 0;
    var extra = isAr
      ? [
          'داخل الإمارات: اطلبي الآن وادفعي بعد الاستلام',
          'اطلبي وأنتِ مطمّنة: ما عجبتك؟ استرجعي فلوسك خلال يومين',
          'استبدال خلال 14 يوم في أي فرع من فروعنا أو بالتوصيل',
          'حقك مضمون مع Al Basha Silver Jewelry'
        ]
      : [
          'UAE only: order now and pay on delivery',
          'Shop worry-free: not happy? Get a refund within 2 days',
          'Exchange within 14 days at any of our branches or by delivery',
          'Your right is guaranteed with Al Basha Silver Jewelry'
        ];
    var copiedLabel = isAr ? '✓ تم النسخ' : '✓ Copied';

    var spans = document.querySelectorAll("[id$='__announcement_bar_NBj8k4'] .announcement-bar__message > span");
    spans.forEach(function (span) {
      if (span.dataset.bsDone) return;
      var text = span.textContent.trim();

      /* slide 1: offer text + code badge */
      var slide1 = document.createElement('span');
      slide1.className = 'bs-slide is-active';
      var m = text.match(CODE_RE);
      var offer = document.createElement('span');
      offer.className = 'bs-offer-text';
      if (m) {
        var code = m[1];
        offer.textContent = [text.slice(0, m.index).trim(), text.slice(m.index + code.length).trim()].filter(Boolean).join(' ');
        slide1.appendChild(offer);
        var badge = document.createElement('span');
        badge.className = 'bs-code';
        badge.textContent = code;
        badge.setAttribute('role', 'button');
        badge.setAttribute('tabindex', '0');
        badge.setAttribute('aria-label', (isAr ? 'انسخي الكود ' : 'Copy code ') + code);
        var copy = function () {
          var done = function () {
            badge.classList.add('is-copied');
            badge.textContent = copiedLabel;
            setTimeout(function () {
              badge.classList.remove('is-copied');
              badge.textContent = code;
            }, 1600);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
          else done();
        };
        badge.addEventListener('click', copy);
        badge.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            copy();
          }
        });
        slide1.appendChild(badge);
      } else {
        offer.textContent = text;
        slide1.appendChild(offer);
      }

      var rot = document.createElement('span');
      rot.className = 'bs-rot';
      rot.setAttribute('aria-live', 'polite');
      rot.appendChild(slide1);

      var slides = [slide1];
      extra.forEach(function (msg) {
        var s = document.createElement('span');
        s.className = 'bs-slide';
        var t = document.createElement('span');
        t.className = 'bs-offer-text';
        t.textContent = msg;
        s.appendChild(t);
        rot.appendChild(s);
        slides.push(s);
      });

      span.textContent = '';
      span.appendChild(rot);
      span.dataset.bsDone = '1';

      var current = 0;
      var paused = false;
      rot.addEventListener('pointerenter', function () { paused = true; });
      rot.addEventListener('pointerleave', function () { paused = false; });

      setInterval(function () {
        if (paused || document.hidden) return;
        var out = slides[current];
        var next = slides[(current + 1) % slides.length];
        next.classList.remove('is-leaving');
        /* start the incoming slide from the left, then move it in */
        next.style.transition = 'none';
        next.classList.remove('is-active');
        void next.offsetWidth;
        next.style.transition = '';
        out.classList.remove('is-active');
        out.classList.add('is-leaving');
        next.classList.add('is-active');
        setTimeout(function () { out.classList.remove('is-leaving'); }, 750);
        current = (current + 1) % slides.length;
      }, INTERVAL);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
